export const getUser = () => {
    const user = JSON.parse(sessionStorage.getItem('dockingmate')) || JSON.parse(localStorage.getItem('dockingmate'));
    return user;
}

export const getToken = () => {
    const token = JSON.parse(sessionStorage.getItem('greenMateToken')) || JSON.parse(localStorage.getItem('greenMateToken'));
    return token;
}